import { nanoid } from 'nanoid';

import { type CreateRawScanEventOptions, type RawScanEvent } from '../types/scanEvent.type';

export const createRawScanEvent = (
  barcodeValue: string,
  { createId = nanoid, now = Date.now }: CreateRawScanEventOptions = {},
): RawScanEvent => ({
  barcodeValue,
  correlationId: createId(),
  detectedAt: new Date(now()).toISOString(),
});
